import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import AdoptionMiddleware from './../modules/adoption/middleware'
import Dialog from 'react-modal'
import DialogConfirm from './../components/Dialog'

const mapStateToProps = ({ adoption }) => ({
  isOpenAdoptionDialog: adoption.dialog.isOpen,
  item: adoption.dialog.item
})

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    changeAdoptionStatus: params => AdoptionMiddleware.changeAdoptionStatus(params),
    toggleDialog: () => AdoptionMiddleware.dialogAdoptionToggleView()
  }, dispatch)
}

class DialogContainer extends Component {
  closeModal = () => (this.props.toggleDialog())
  render () {
    return (
      <Dialog
        isOpen={this.props.isOpenAdoptionDialog}
        contentLabel='Modal'
        className='dialog dialog--confirm'
      >
        <DialogConfirm
          closeDialog={this.closeModal}
          item={this.props.item}
          changeAdoptionStatus={this.props.changeAdoptionStatus}
        />
      </Dialog>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DialogContainer)



// WEBPACK FOOTER //
// ./src/containers/DialogContainer.js